
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cam-model-protection",
      function () {
        return require("private-next-pages/cam-model-protection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cam-model-protection"])
      });
    }
  